// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { createLinkIconStyles } from "@guestsupply/XDL/Utilities";
import { productAddToListLinkStyles } from "@insite/content-library/Components/ProductAddToListLink";
import Plus from "@insite/mobius/Icons/Plus";
import { css } from "styled-components";

productAddToListLinkStyles.link = {
    ...createLinkIconStyles(Plus, {
        typographyProps: {
            size: 12,
        },
        icon: {
            iconProps: {
                css: css`
                    &,
                    & > svg {
                        height: 16px;
                        width: 14px;
                    }
                `,
            },
            position: "left",
        },
    }),
};
